import { BarChart } from "@mui/x-charts/BarChart";
import { Card, CardContent, Typography } from "@mui/material";

interface MessageSummaryProps {
    sent: number;
    read: number;
    ignored: number;
}

export default function MessageSummaryChart({ sent, read, ignored }: MessageSummaryProps) {
    const data = [
        { label: "Sent", value: sent },
        { label: "Read", value: read },
        { label: "Ignored", value: ignored },
    ];

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6">Summary</Typography>
                <BarChart
                    dataset={data}
                    borderRadius={4}
                    slotProps={{ legend: { hidden: true } }}
                    xAxis={[{
                        scaleType: "band", dataKey: "label", tickLabelPlacement: "middle",
                        colorMap: { type: "ordinal", colors: ["#8884d8", "#82ca9d", "#ff6961"] }
                    }]}
                    series={[
                        { dataKey: "value", label: "" },
                    ]}
                    barLabel="value"
                    width={500}
                    height={300}
                />
            </CardContent>
        </Card>
    );
}
